export const ScrollToContent = (targetId) => {
    const targetElement = document.querySelector(targetId);
    const navbarHeight = document.querySelector('.navbar')?.offsetHeight || 0;
  
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - navbarHeight,
        behavior: 'smooth',
      });
    }
  };
  